import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";

interface TemplateBasicInfoProps {
  name: string;
  setName: (value: string) => void;
  description: string;
  setDescription: (value: string) => void;
  templateType: string;
  setTemplateType: (value: string) => void;
  targetAudience: string;
  setTargetAudience: (value: string) => void;
}

export const TemplateBasicInfo = ({
  name,
  setName,
  description,
  setDescription,
  templateType,
  setTemplateType,
  targetAudience,
  setTargetAudience,
}: TemplateBasicInfoProps) => {
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="name">Template Name</Label>
        <Input
          id="name"
          placeholder="Enter template name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      </div>

      <div>
        <Label htmlFor="type">Template Type</Label>
        <Select value={templateType} onValueChange={setTemplateType} required>
          <SelectTrigger>
            <SelectValue placeholder="Select template type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="daily">Daily Newsletter</SelectItem>
            <SelectItem value="weekly">Weekly Digest</SelectItem>
            <SelectItem value="monthly">Monthly Report</SelectItem>
            <SelectItem value="welcome">Welcome Email</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          placeholder="Enter template description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={2}
        />
      </div>

      <div>
        <Label htmlFor="target">Target Audience</Label>
        <Select value={targetAudience} onValueChange={setTargetAudience}>
          <SelectTrigger>
            <SelectValue placeholder="Select target audience" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Subscribers</SelectItem>
            <SelectItem value="technical">Technical Users</SelectItem>
            <SelectItem value="business">Business Users</SelectItem>
            <SelectItem value="consumer">General Consumers</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};